<template>
	<v-dialog v-model="showDialog" persistent scrollable :max-width="$vuetify.breakpoint.mobile ? '90%' : '75%'">
		<v-card class="justify-center text-center card-rounded pb-5" min-height="90vh">
			<v-card-title
				class="pa-2 white--text justify-center text-center secondary"
				style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
			>
				<v-row>
					<v-spacer></v-spacer>
					<span class="headline white--text">Meet our Locums</span>
					<v-spacer></v-spacer>
				</v-row>
				<v-btn icon color="white" @click="dismissFeaturedLocums">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text class="text-center justify-center">
				<v-container class="card-rounded pb-2 text-center justify-center">
					<v-row :class="width >= 1264 ? 'pr-8 pl-7' : ''">
						<v-col cols="12" md="3" :class="{ 'mb-0': width <= 475, shrink: true }">
							<v-select
								v-model="filterProfession"
								label="Select profession"
								outlined
								dense
								style="height: 40px"
								:items="filterProfessionOptions"
								@input="searchLocums(false)"
							></v-select>
						</v-col>
						<v-col v-if="showSkillsAndExperience" cols="12" md="3" :class="{ 'mb-0': width <= 475, shrink: true }">
							<v-select
								v-model="selectedSkills"
								:items="availableSkills"
								item-text="name"
								item-value="code"
								outlined
								dense
								multiple
								label="Skills & Experience"
								@input="searchLocums"
							>
								<template #selection="{ item, index }">
									<v-chip v-if="index === 0" small>
										<span>{{ item.name }}</span>
									</v-chip>
									<span v-if="index === 1" class="grey--text text-caption"> (+{{ selectedSkills.length - 1 }} others) </span>
								</template>
							</v-select>
						</v-col>
						<v-col cols="12" md="3" :class="{ 'mb-0': width <= 475, shrink: true, 'pr-0': width > 960 && width < 1120, 'd-none': width >= 960 }">
							<v-text-field v-model="searchText" dense label="Search by first name" style="height: 40px" outlined @keyup="searchLocums"></v-text-field>
						</v-col>
						<v-col cols="12" md="1" :class="{ 'pl-0': width >= 960 && width < 1120 }">
							<v-btn class="mb-4" depressed color="secondary" :class="{ 'pr-1 pl-1': width > 960 && width < 1120 }" @click="resetFilters">Reset</v-btn>
						</v-col>
						<v-col cols="12" :md="showSkillsAndExperience ? 5 : 8">
							<div :v-model="active_tab" class="mb-5 text-right">
								<strong class="mr-3" :class="{ 'mb-3': width <= 475, 'd-block': width <= 475 }">Sort By:</strong>
								<span :class="{ 'd-flex': width <= 400 }">
									<span
										v-for="(option, i) in sortOptions"
										:key="i"
										:class="{ 'primary--text': active_tab === i, 'pt-3': width <= 960, 'd-flex': width <= 390 }"
										style="cursor: pointer"
										@click="refreshSearch(option.replace(/\s/g, '').toLowerCase(), true)"
									>
										{{ option }}
										<v-icon v-if="active_tab === i && ascending" :class="active_tab === i ? 'primary--text' : ''" size="20">mdi-arrow-up-thin</v-icon>
										<v-icon v-if="active_tab === i && !ascending" :class="active_tab === i ? 'primary--text' : ''" size="20">mdi-arrow-down-thin</v-icon>
										<span class="mr-3"></span>
									</span>
								</span>
							</div>
						</v-col>
					</v-row>
					<v-row :class="{ 'pr-8 pl-7': width >= 1264, 'd-none': width < 960 }">
						<v-col cols="12" md="3" :class="{ 'mb-2': true, shrink: true, 'pr-0': width > 960 && width < 1120, 'pt-0': true }">
							<v-text-field v-model="searchText" dense label="Search by first name" style="height: 40px" outlined @keyup="searchLocums"></v-text-field>
						</v-col>
					</v-row>
				</v-container>
				<v-container v-if="isLoaded" class="card-rounded pb-2 text-center justify-center">
					<v-row class="text-center">
						<v-col v-for="(locum, i) in locumsToDisplay" :key="i" cols="12" sm="6" md="4" class="text-center">
							<featured-locum-card :locum="locum" :locum-index="i" :reload-image="reloadAvatars" @clicked="onQuickBookLocum"></featured-locum-card>
						</v-col>
					</v-row>
					<div v-if="locumsToDisplay.length === 0 && isLoaded" class="text-center text--gray mb-8 mt-10">No locums to display. Try resetting your search criteria.</div>
					<v-row v-if="showMoreLocumsButton" class="pt-5 pb-2 justify-center text-center">
						<v-col>
							<v-btn class="button-rounded continue-signup-button" style="text-transform: none !important" color="primary" @click="nextPage"
								>More locums<v-icon>replay</v-icon></v-btn
							>
						</v-col>
					</v-row>
				</v-container>

				<v-container v-else class="mt-4">
					<v-row justify="center" align="center">
						<v-progress-circular color="secondary" indeterminate></v-progress-circular>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { bus } from '@/main';
import store from '@/store';
import axios from 'axios';
import moment from 'moment';

import FeaturedLocumCard from './FeaturedLocumCard.vue';
import { getRelevantProfessions } from '@utils';

export default {
	name: 'PracticeFeaturedLocumsDialog',
	components: {
		FeaturedLocumCard,
	},
	props: {},
	data: () => ({
		showDialog: false,
		randomLocumIndexes: [],
		randomLocums: [],
		locums: [],
		total: 9,
		currentPage: 0,
		isLoaded: false,
		debugMode: false,
		active_tab: null,
		ascending: true,
		searchText: '',
		unsortedLocums: [],
		sortedLocums: [],
		locumsToDisplay: [],
		fetchedLocums: false,
		reloadAvatars: 0,
		filterProfession: '',
		filterProfessionOptions: [],
		loaderTimeout: null,
		selectedSkills: [],
		industriesV2: store.getters.configs.industriesV2,

		sortOptions: ['First Name', 'Experience', 'Rates'],

		filterOptionValues: {
			0: 'firstname',
			1: 'experience',
			2: 'rates',
		},
	}),
	computed: {
		company() {
			return store.getters.company;
		},

		manager() {
			return store.getters.user;
		},

		requests() {
			const token = store.getters.jwtToken;
			if (this.industriesConfigsObj) {
				const relevantProfessions = getRelevantProfessions(this.company.industry, this.industriesConfigsObj);
				return relevantProfessions.map(profession => axios.get(store.getters.getAPI + '/professionals/search/' + profession, { headers: { Authorization: token } }));
			} else {
				return [];
			}
		},

		width() {
			return this.$vuetify.breakpoint.width;
		},

		industriesConfigsObj() {
			return store.getters.configs.industries;
		},

		showMoreLocumsButton() {
			const isFinalLocum = this.isFinalLocum();
			return this.isLoaded && !(isFinalLocum && this.currentPage === 0) && !(this.filterProfession && this.currentLocums.length <= this.total);
		},

		currentLocums() {
			return [0, 1, 2].includes(this.active_tab) || this.searchActive || this.filterProfession ? this.sortedLocums : this.unsortedLocums;
		},

		searchActive() {
			return this.searchText.trim() !== '';
		},

		industryObjectV2() {
			const { industry } = this.company || {};

			if (industry && this.industriesV2 && this.filterProfession) {
				return this.industriesV2[industry]?.professions.find(({ name }) => name === this.filterProfession);
			}
			return undefined;
		},

		availableSkills() {
			if (!this.company.industry) return undefined;

			if (this.industryObjectV2?.skills) {
				let flattenedSkills = [];

				for (let skill of this.industryObjectV2.skills) {
					if (skill.options?.length) {
						for (let { code, name: optionName } of skill.options) {
							flattenedSkills.push({
								code,
								name: `${skill.name} - ${optionName}`,
							});
						}
					} else {
						flattenedSkills.push(skill);
					}
				}

				return flattenedSkills;
			} else {
				return undefined;
			}
		},

		showSkillsAndExperience() {
			return this.filterProfession && this.industryObjectV2 && this.availableSkills;
		},
	},
	watch: {
		randomLocumIndexes: function (val, oldVal) {
			if (oldVal.length != val.length) {
				this.randomLocumIndexes.sort((aIndex, bIndex) => {
					const locA = this.locums[aIndex];
					const locB = this.locums[bIndex];
					let aCompare = 0;
					let bCompare = 0;
					if (locA.avatar && locA.avatar != 'no-avatar') {
						aCompare = 1;
					} else if (!('avatar' in locA)) {
						aCompare = -1;
					}

					if (locB.avatar && locB.avatar != 'no-avatar') {
						bCompare = 1;
					} else if (!('avatar' in locB)) {
						bCompare = -1;
					}

					return aCompare - bCompare;
				});
			}
		},
		industriesConfigsObj: function (val) {
			if (val && !this.fetchedLocums) {
				this.getAllLocums();
			}
		},
		locumsToDisplay: function () {
			this.reloadAvatars += 1;
		},
		filterProfession() {
			this.selectedSkills = [];
		},
	},
	async mounted() {
		bus.$on('dismiss-featured-popup', () => {
			this.showDialog = false;
		});

		bus.$on('show-featured-popup', () => {
			this.showDialog = true;
		});

		if (this.industriesConfigsObj && !this.fetchedLocums) {
			this.getAllLocums();
		}

		this.setLoadedTrue();
	},
	methods: {
		sortLocums(locums, getField) {
			return locums.sort((locumA, locumB) => {
				let valueA = getField(locumA);
				let valueB = getField(locumB);
				if (typeof valueA === 'string' && typeof valueB === 'string') {
					valueA = valueA.toLowerCase();
					valueB = valueB.toLowerCase();
				}
				if (valueA < valueB) return this.ascending ? -1 : 1;
				if (valueA > valueB) return this.ascending ? 1 : -1;
				return 0;
			});
		},

		searchLocums(searchSkills = true) {
			this.isLoaded = false;

			let filteredLocums = this.unsortedLocums.filter(({ first_name = '', profession, skills = [] }) => {
				const professionMatch = this.filterProfession ? profession === this.filterProfession : true;
				const skillsMatch = searchSkills && this.selectedSkills?.length ? this.selectedSkills.some(selectedSkill => skills.includes(selectedSkill)) : true;
				return first_name.toLowerCase().includes(this.searchText.trim().toLowerCase()) && professionMatch && skillsMatch;
			});
			if (this.active_tab !== null) {
				const { getField } = this.getActiveFilter(this.filterOptionValues[this.active_tab]);
				filteredLocums = this.sortLocums(filteredLocums, getField);
			} else {
				this.sortedLocums = this.sortLocums(filteredLocums, this.sortByAvatar);
			}
			if (this.currentPage >= filteredLocums.length) {
				this.currentPage = 0;
			}
			this.sortedLocums = filteredLocums;
			this.locumsToDisplay = this.getCurrentLocums(filteredLocums);

			this.setLoadedTrue();
		},

		getMinRate(locum) {
			if (locum && locum.working_hours) {
				const ratesArray = Object.values(locum.working_hours).map(({ rate }) => Number(rate));
				if (ratesArray.length === 0) {
					return 0;
				}
				return Math.min(...ratesArray);
			} else {
				return 0;
			}
		},

		getActiveFilter(filterBy) {
			let getField, active_tab;
			switch (filterBy) {
				case 'firstname':
					getField = locum => (locum.first_name ? locum.first_name : 'z');
					active_tab = 0;
					break;
				case 'experience':
					getField = locum => this.getYearsExperience(locum);
					active_tab = 1;
					break;
				case 'rates':
					getField = locum => this.getMinRate(locum);
					active_tab = 2;
					break;
			}
			return { getField, active_tab };
		},

		sortByAvatar({ documents }) {
			return documents && documents.images && documents.images.includes('avatar') ? 'a' : 'z';
		},

		isFinalLocum() {
			const { id: lastCurrentId } = this.currentLocums[this.currentLocums.length - 1] || {};
			const { id: lastDisplayId } = this.locumsToDisplay[this.locumsToDisplay.length - 1] || {};
			return lastCurrentId && lastDisplayId && lastCurrentId === lastDisplayId;
		},

		setLoadedTrue(t = 500) {
			if (this.loaderTimeout) clearTimeout(this.loaderTimeout);
			this.loaderTimeout = setTimeout(() => {
				this.isLoaded = true;
				clearTimeout(this.loaderTimeout);
			}, t);
		},

		resetFilters() {
			this.isLoaded = false;
			this.active_tab = null;
			this.searchText = '';
			this.currentPage = 0;
			this.filterProfession = '';
			this.selectedSkills = [];
			this.locumsToDisplay = this.getCurrentLocums(this.unsortedLocums);

			this.setLoadedTrue();
		},

		async onQuickBookLocum(payload) {
			bus.$emit('dismiss-featured-popup');
			bus.$emit('show-quickbook-popup', payload);
		},

		dismissFeaturedLocums() {
			sessionStorage.setItem('featuredLocumsDismissed', true);
			bus.$emit('dismiss-featured-popup');
		},

		async getAllLocums() {
			let responses = await axios.all(this.requests);
			let company = this.company;
			responses
				.map(response => response.data.data.Items)
				.forEach(search_response => {
					search_response
						.filter(locum => locum.address.province === company.address.province && locum.approved === true && !locum.IsDeleted)
						.forEach(locum => {
							if (!this.filterProfessionOptions.includes(locum.profession)) {
								this.filterProfessionOptions.push(locum.profession);
							}
							this.locums.push(locum);
							this.unsortedLocums.push(locum);
						});
				});

			this.unsortedLocums = this.sortLocums(this.unsortedLocums, this.sortByAvatar);
			this.locumsToDisplay = this.getCurrentLocums(this.unsortedLocums);

			this.setLoadedTrue(2000);
		},

		getYearsExperience(locum) {
			return 'experience' in locum ? moment().diff(locum.experience.start_date, 'years') : 0;
		},

		getCurrentLocums(locums) {
			return locums.slice(this.currentPage, this.currentPage + this.total);
		},

		async refreshSearch(filterBy, changeSort) {
			this.isLoaded = false;
			let locums = this.currentLocums;

			if (changeSort) {
				this.ascending = !this.ascending;
				this.currentPage = 0;
			}

			if (this.debugMode) {
				let filteredLocums = [];
				const emails = ['mondaydemoloc@locumbase.com', 'medicaldoctordemo@locumbase.com'];
				emails.forEach(email => {
					let int = locums.findIndex(locum => locum.email == email);
					if (int > -1) {
						filteredLocums.push(locums[int]);
					}
				});
				locums = filteredLocums;
			}

			if (filterBy) {
				const { getField, active_tab } = this.getActiveFilter(filterBy);

				this.active_tab = active_tab;

				if (this.searchActive) {
					this.searchLocums();
				} else {
					if (this.filterProfession) {
						locums = locums.filter(({ profession }) => profession === this.filterProfession);
					}
					this.sortedLocums = this.sortLocums(locums, getField);
					this.locumsToDisplay = this.getCurrentLocums(this.sortedLocums);
					this.setLoadedTrue();
				}
			} else {
				let ints = [];
				if (!this.debugMode) {
					const getField = locum => this.getYearsExperience(locum);
					this.sortedLocums = this.sortLocums(locums, getField);
					this.locumsToDisplay = this.getCurrentLocums(this.sortedLocums);
					this.setLoadedTrue();
				} else {
					const emails = ['mondaydemoloc@locumbase.com', 'medicaldoctordemo@locumbase.com'];
					emails.forEach(email => {
						let int = locums.findIndex(locum => locum.email == email);
						if (int > -1) {
							ints.push(int);
						}
					});
				}
				this.randomLocumIndexes = ints;
			}
		},
		nextPage() {
			this.isLoaded = false;

			this.currentPage += 9;
			const locums = this.currentLocums;
			if (this.currentPage >= locums.length) {
				this.currentPage = 0;
			}
			this.locumsToDisplay = this.getCurrentLocums(locums);

			this.setLoadedTrue();
		},
	},
};
</script>
